import { DataTypeRendererSizes } from '../dataTypeOptions'

export const TAG_LAYOUT = {
  rounded: '4px',
  paddingX: '10px',
  paddingY: '4px',
  skeletonHeightOffset: '8px',
  /** Chakra `Text` default `medium` size line height used by `TagRenderer`. */
  textLineHeight: '16px',
  /** Inner widths for a representative supplemental tag e.g. "Load Configuration: Palletised". */
  supplementalSkeleton: {
    labelWidth: '160px',
    valueWidth: '72px',
    innerGap: '4px',
  },
} as const

const TAG_SIZE_STYLES: Record<
  DataTypeRendererSizes,
  { fontSize: string; skeletonWidth: string }
> = {
  xl: {
    fontSize: '32px',
    skeletonWidth: '160px',
  },
  large: {
    fontSize: '24px',
    skeletonWidth: '140px',
  },
  medium: {
    fontSize: '12px',
    skeletonWidth: '120px',
  },
  small: {
    fontSize: '10px',
    skeletonWidth: '80px',
  },
}

export const TagLayout = {
  sizeStyles: (size: DataTypeRendererSizes = 'medium') => TAG_SIZE_STYLES[size],
  skeletonHeight: (fontSize: string) =>
    `calc(calc(${fontSize} * 1.5) + ${TAG_LAYOUT.skeletonHeightOffset})`,
  supplementalSkeletonStyles: () => ({
    width: `calc((${TAG_LAYOUT.paddingX} * 2) + ${TAG_LAYOUT.supplementalSkeleton.labelWidth} + ${TAG_LAYOUT.supplementalSkeleton.innerGap} + ${TAG_LAYOUT.supplementalSkeleton.valueWidth})`,
    height: `calc(${TAG_LAYOUT.textLineHeight} + calc(${TAG_LAYOUT.paddingY} * 2))`,
    rounded: TAG_LAYOUT.rounded,
  }),
} as const
